/* eslint-disable @typescript-eslint/no-explicit-any */
import api from "./api";

export type EntityTypes =
  | "FINANCPAG"
  | "FINANCREC"
  | "EDUALUNO"
  | "RHCOLLAB"
  | "FINANCMOV"
  | "COMPRAS"
  | "FORNECEDOR"
  | "CUSTOMERS";

export const loadDocuments = async (uid_vinculo: string) => {
  try {
    const res = await api.get(`/documentsManager/list`, {
      params: { uid_vinculo },
    });

    return res.data?.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      "Erro ao carregar documentos!"
    );
  }
};

export const registerOrEditDocumentType = async (data: {
  uid_tipo_documento?: string;
  titulo: string;
  grupo: string;
  codigo_entidade: EntityTypes;
}) => {
  try {
    const res = await api.post(
      "/documentsManager/registerOrEditDocumentType",
      data,
    );
    return res.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Erro ao salvar tipo de documento";
  }
};

export const getDocumentTypes = async (entidade: string) => {
  try {
    const res = await api.get(
      `/documentsManager/getDocumentTypes?entidade=${entidade}`,
    );
    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      "Erro desconhecido ao carregar tipos de documento!"
    );
  }
};

export const uploadDocumentFinanceiro = async (
  file: File,
  uid_entidade: string,
  uid_tipo_documento: string,
  uid_vinculo: string,
) => {
  try {
    const formData = new FormData();

    formData.append("anexo", file);

    formData.append("uid_entidade", uid_entidade);
    formData.append("uid_tipo_documento", uid_tipo_documento);
    formData.append("uid_vinculo", uid_vinculo);

    const res = await api.post("/documentsManager/documentUpload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      "Erro ao realizar upload do documento financeiro!"
    );
  }
};

export const getAllProjectDocumentTypes = async () => {
  const res = await api.get("/documentsManager/getAllProjectDocumentTypes");
  return res.data;
};

export const deleteDocumentTypeAssociation = async (
  uid_tipo_documento: string,
  entidade: string,
) => {
  try {
    const res = await api.delete(`/documentsManager/deleteTypeAssociation`, {
      params: { uid_tipo_documento, codigo_entidade: entidade },
    });
    return res.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Erro ao excluir vínculo";
  }
};

export const getDocumentFile = async (uid_documento: string) => {
  try {
    const res = await api.get(`/documentsManager/doc/${uid_documento}`);
    return res.data?.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      "Erro ao realizar download do documento!"
    );
  }
};

export const deleteDocument = async (uid_documento: string) => {
  try {
    const res = await api.delete(`/documentsManager/delete/${uid_documento}`);
    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      "Erro ao excluir o documento!"
    );
  }
};

export const getDocumentHistory = async (
  uid_vinculo: string,
  uid_tipo_documento: string,
) => {
  try {
    if (!uid_tipo_documento) return [];

    const res = await api.get(`/documentsManager/history`, {
      params: { uid_vinculo, uid_tipo_documento },
    });

    return res.data?.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      "Erro ao carregar histórico!"
    );
  }
};

export const updateDocument = async (data: {
  uid_documento: string;
  titulo?: string;
  descricao?: string;
  inicio?: string;
  fim?: string;
}) => {
  try {
    const res = await api.put("/documentsManager/updateDoc", data);
    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message || "Erro ao atualizar dados do documento"
    );
  }
};

export const softDeleteDocument = async (uid_documento: string) => {
  try {
    const res = await api.delete(
      `/documentsManager/softDelete/${uid_documento}`,
    );
    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      "Erro ao excluir o documento!"
    );
  }
};
